module.exports = __webpack_public_path__ + "img/resourceBlue.304031b0.png";